import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailConfigerationComponent } from '../emailconfiguration/email-configeration.component';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigService } from 'src/app/shared/services/config.service';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { countryReference } from 'src/app/utils/constants/strings';

@Component({
  selector: 'app-email-mapping',
  templateUrl: './email-mapping.component.html',
  styleUrls: ['./email-mapping.component.css'],
})
export class EmailMappingComponent implements OnInit {
  emailData: MatTableDataSource<any>;
  emailDataArray = [];
  configData: any;
  destinationList = countryReference;
  displayedColumns: string[] = [
    'Destination',
    'babyDestServiceCode',
    'companyName',
    'commercialInvoice',
    'reportparams',
    'action',
  ];

  constructor(private dialog: MatDialog, private configService: ConfigService) {}

  ngOnInit(): void {
    this.getEmailMappingList();
  }

  openEditorCreatePopup(value, index, action) {
    const dialogRef = this.dialog.open(EmailConfigerationComponent, {
      disableClose: true,
      maxHeight: '100vh',
      maxWidth: '80vw',
      data: {
        mappingData: value,
        labelName: action,
        index: index,
        configData: this.configData,
      },
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data == 'true') {
        this.getEmailMappingList();
      }
    });
  }

  getEmailMappingList() {
    this.configService.fetchConfig('prealert_emails').then(res => {
      this.emailDataArray = [];
      this.configData = res;
      const counrtyData = res.data;
      if (counrtyData) {
        for (const country of counrtyData) {
          const destCode = country.Destination;
          if (destCode) {
            const destinationCountryName = this.destinationList.find(x => x.code == destCode).name;
            const CountryObj: any = {};
            CountryObj.Destination = destinationCountryName;
            CountryObj.EmailList = country.EmailList;
            CountryObj.reportparams = country.reportparams;
            CountryObj.emailContent = country.emailContent;
            CountryObj.senderEmail = country.senderEmail;
            CountryObj.companyName = country.companyName;
            CountryObj.commercialInvoice = country.commercialInvoice;
            CountryObj.babyDestServiceCode = country.babyDestServiceCode;
            this.emailDataArray.push(CountryObj);
          }
        }
      }
      this.emailData = new MatTableDataSource(this.emailDataArray);
    });
  }

  deleteEmailConfig(element) {
    const dailogData = {
      message: 'alert.deleteEmailCountry',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        this.deleteCountry(element);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  deleteCountry(element) {
    const destinationCountryCode = this.destinationList.find(
      con => con.name === element.Destination
    ).code;
    const config = this.configData.data;
    const countryIndex = config.findIndex(x => x.Destination == destinationCountryCode);
    if (countryIndex > -1) {
      const serviceCodeIndex = config.findIndex(
        y => y.babyDestServiceCode == element.babyDestServiceCode
      );
      if (serviceCodeIndex > -1) {
        config.splice(serviceCodeIndex, 1);
      }
    }
    this.configData.data = config;

    this.savePreConfig();
  }

  savePreConfig() {
    this.configService.saveConfig(this.configData).subscribe(() => {
      this.configService.putConfig(this.configData.config_id, this.configData.data);
      this.getEmailMappingList();
    });
  }
}
